import React, { useEffect } from 'react';
import { connect, shallowEqual, useDispatch, useSelector } from 'react-redux';
import { prepareChatStore } from '@beef/layout-kit/store';
import classNames from 'classnames/bind';

import { getBasketData } from 'store/common/basket/actions';
import { getModifiedHeaderData } from 'store/common/header/selectors';
import { fetchHeaderModel2024 } from 'store/common/specialProjectHeader/common';
import { selectIsHeaderModelLoaded } from 'store/common/specialProjectHeader/selectors';
import Header2024 from 'components/Header2024';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

/**
 * Header exists and doesn't exist at the same time
 * we do not trust shopfront to properly return header data
 * so if the data is empty or simply crashes header somehow,
 * we simply turn header off
 */
const SchrodingersHeader = React.forwardRef(({ isHeaderModel2024Loaded }, ref) => {
  const dispatch = useDispatch();
  const { data } = useSelector(
    (state) => ({
      data: getModifiedHeaderData(state),
    }),
    shallowEqual,
  );

  useEffect(() => {
    dispatch(fetchHeaderModel2024());
    dispatch(getBasketData());
    prepareChatStore();
  }, []);

  return (
    <>
      <div
        className={cx('header')}
        ref={ref}
        style={{ ...(!isHeaderModel2024Loaded ? { pointerEvents: 'none' } : {}) }}
      >
        <Header2024 />
      </div>
      {/* для flocktory */}
      {data?.auth?.user && (
        <div className="i-flocktory" data-fl-user-email={`${data.auth.user.ctn}@unknown.email»`} />
      )}
    </>
  );
});

export default connect(
  (state) => ({ isHeaderModel2024Loaded: selectIsHeaderModelLoaded(state) }),
  null,
  null,
  { forwardRef: true },
)(SchrodingersHeader);
